// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__8B7CX","info":"style__info__rmA5c"};